import columns from '../../../../../../react-table/helpers/columns';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';

export function getDetailsTabNavigationProps(rowInfo) {
  return rowInfo && rowInfo.row ? {
    reportId: ReportDefinitions.PREDES_COMPLIANCE_MISSING_MANDATORY_ELEMENTS_ERROR_MESSAGES.id,
    mainReportId: ReportDefinitions.PREDES_COMPLIANCE_MISSING_MANDATORY_ELEMENTS_SUMMARY.id,
    requestParams: {
      operator: rowInfo.row['sender'], // eslint-disable-line
      senderId: rowInfo.row['sendingMailbox'], // eslint-disable-line
      organisation: rowInfo.original.organisation, // eslint-disable-line
    },
    selectionCriteriaOptions: {
      includeSelectionCriteria: true,
    },
    reportsToBeCleared: [
      ReportDefinitions.PREDES_COMPLIANCE_MISSING_MANDATORY_ELEMENTS_KEY_DETAILS.id,
    ],
  } : {};
}

export default (data) => {
  const {
    TextColumn,
    NonZeroNumberColumn,
    DateTimeColumn,
    NavigationColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new TextColumn('Sender', 'sender'),
        new TextColumn('Sending mailbox', 'sendingMailbox'),
        new NavigationColumn(new NonZeroNumberColumn('Number of messages', 'numberOfMessages'), getDetailsTabNavigationProps),
        new DateTimeColumn('First occurrence', 'firstOccurrenceDate'),
        new DateTimeColumn('Last occurrence', 'lastOccurrenceDate'),
      ],
    },
  ];
};
